(function($, ns, _) {
    'use strict';

    var cfg = {
        cache: {
            searchBtn: '[data-js="free-text-search-btn"]',
            totalResults: '[data-js="total-results"]',
            resultsContainer: '[data-js="results-container"]',
            noResultsContainer: '[data-js="no-results-container"]',
            suggestionsContainer: '[data-js="suggestion-container"]',
            suggestionLink: 'a',
            suggestionText: 'strong',
            searchPane: '.search-container',
            closeBtn: '.btn-dismiss',
            searchInput: 'input',
            searchResults: '.search-results',
            searchResultsList: 'ul',
            searchAllBtn: '.btn-search-all',
            externalSearchToggle: '[data-toggle="search"]',
            header: 'header'
        },
        classes: {
            active: 'active',
            searchIcon: 'icon-search',
            closeIcon: 'icon-times',
            searchOpen: 'search-open'
        },
        events: {
            click: 'click',
            change: 'change',
            keyup: 'keyup'
        },
        options: {
            screenWidth: '990'
        }
    };

    ns.Search = function(container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.Search.prototype = {
        init: function() {
            this.cacheItems();
            if (this.searchBtn.length) {
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var cache = this.settings.cache;

            this.searchBtn = $(cache.searchBtn);
            this.closeBtn = this.container.find(cache.closeBtn);

            this.searchInput = this.container.find(cache.searchInput);
            this.searchResults = $(cache.searchResults);
            this.searchResultsList = this.searchResults.find(cache.searchResultsList);

            this.totalResults = this.container.find(cache.totalResults);

            this.resultsContainer = this.container.find(cache.resultsContainer);
            this.noResultsContainer = this.container.find(cache.noResultsContainer);
            this.suggestionsContainer = this.container.find(cache.suggestionsContainer);

            this.suggestionLink = this.suggestionsContainer.find(cache.suggestionLink);
            this.suggestionText = this.suggestionLink.find(cache.suggestionText);

            this.searchAllBtn = this.container.find(cache.searchAllBtn);
            this.searchBtn = this.searchBtn.add(cache.externalSearchToggle);
            this.searchToggle = $(cache.searchBtn)
                .children('i')
                .first();

            this.header = $(cache.header);

            this.searchResultsCache = {};
            this.apiUrl = this.container.data('search-endpoint');
            this.pageSize = this.container.data('page-size');
            this.searchDelay = this.container.data('search-delay');
        },
        bindEvents: function() {
            var settings = this.settings,
                classes = settings.classes,
                events = settings.events,
                options = settings.options;

            this.searchBtn.on(events.click, () => {
                this.header.toggleClass(classes.searchOpen);
                this.container.toggleClass(classes.active);
                this.searchInput.focus();
                this.searchResults.removeClass(classes.active);
                this.searchInput.val('');

                if ($(window).width() < options.screenWidth) {
                    this.searchToggle.toggleClass(classes.closeIcon);
                    this.searchToggle.toggleClass(classes.searchIcon);
                }
            });

            this.closeBtn.on(events.click, () => {
                this.searchResults.removeClass(classes.active);
                if ($(window).width() < options.screenWidth) {
                    this.searchToggle.toggleClass(classes.closeIcon);
                    this.searchToggle.toggleClass(classes.searchIcon);
                }
                setTimeout(() => {
                    this.header.removeClass(classes.searchOpen);
                    this.container.removeClass(classes.active);
                    this.searchInput.val('');
                }, 200);
            });

            this.searchInput.on(
                events.keyup,
                _.debounce(e => {
                    if (e.keyCode === 27) {
                        this.closeBtn.trigger(events.click);
                    } else if (e.keyCode === 13) {
                        let searchTerm = this.searchInput.val();
                        window.location.href = this.searchAllBtn
                            .data('url')
                            .replace('{0}', searchTerm.trim());
                    } else {
                        let searchTerm = this.searchInput.val();
                        if (searchTerm.trim().length >= 3) {
                            this.searchResults.addClass(classes.active);
                            this.doSearch(searchTerm);
                        } else {
                            this.searchResults.removeClass(classes.active);
                        }
                    }
                }, this.searchDelay)
            );
        },
        activate: function() {},
        doSearch: function(searchTerm) {
            let url = this.searchAllBtn.data('url');

            // Trim search so we don't invoke the search api twice for the same results;
            searchTerm = searchTerm.trim();
            this.activeSearchTerm = searchTerm;

            // Update search all button;
            url = url.replace('{0}', searchTerm);
            this.searchAllBtn.attr('href', url);

            // Chech our simple cache mechanism for results;
            let cacheResult = this.searchResultsCache[searchTerm];
            if (cacheResult && cacheResult !== undefined) {
                this.updateSearchResultList(cacheResult);
            } else {
                // If we don't have any cached results fire an api call;
                $.ajax({
                    type: 'GET',
                    url: this.apiUrl,
                    data: {
                        searchTerm: searchTerm,
                        maxResults: this.pageSize
                    },
                    error: (xhr, status, error) => {
                        if (status !== 'abort') {
                            // No need to handle an error yet
                            console.error(status, error);
                        }
                    },
                    success: response => {
                        if (response) {
                            // If the current callback is not the request for the active searchTerm don't update the result list
                            if (this.activeSearchTerm && this.activeSearchTerm === searchTerm) {
                                this.updateSearchResultList(response);
                            }
                            this.searchResultsCache[searchTerm] = response;
                        }
                    }
                });
            }
        },
        updateSearchResultList: function(data) {
            let results = data.items;
            let url = this.searchAllBtn.data('url');

            this.totalResults.html('');
            this.searchResultsList.children().remove();

            this.resultsContainer.show();
            this.searchAllBtn.show();
            this.noResultsContainer.hide();
            this.suggestionsContainer.hide();

            if (!results || results.length === 0) {
                if (data.suggestion) {
                    console.log('Suggestion found');
                    this.suggestionLink.attr('href', url.replace('{0}', data.suggestion));
                    this.suggestionText.html(data.suggestion);

                    this.resultsContainer.hide();
                    this.searchAllBtn.hide();
                    this.noResultsContainer.hide();
                    this.suggestionsContainer.show();
                } else {
                    console.log('No results found');
                    this.resultsContainer.hide();
                    this.searchAllBtn.hide();
                    this.noResultsContainer.show();
                    this.suggestionsContainer.hide();
                }
            } else {
                console.log('Results found');
                for (let i = 0; i < results.length; i++) {
                    let result = results[i],
                        text = result.title,
                        sourceText = text,
                        outputText = '',
                        lastIndex = 0;

                    if (result.titleHighlights.length) {
                        let remaingText = text;
                        for (let j = 0; j < result.titleHighlights.length; j++) {
                            let highlight = result.titleHighlights[j],
                                endIndex = highlight.Offset + highlight.Length,
                                fragment = text.substring(highlight.Offset, endIndex),
                                textArray = remaingText.split(fragment);

                            remaingText = textArray[1];
                            outputText += textArray[0] + `<strong>${fragment}</strong>`;
                            lastIndex = endIndex;
                        }
                    }
                    if (lastIndex === 0) {
                        outputText = text;
                    } else {
                        outputText += sourceText.substring(lastIndex);
                    }

                    this.searchResultsList.append(
                        $(
                            `<li><a href="${
                                result.printableUri
                            }" class="search-result"><span class="search-icon icon-${
                                result.categoryIcon
                            }"></span>${outputText}<span class="search-category">${
                                result.categoryName
                            }</span></a></li>`
                        )
                    );
                }
                this.totalResults.html(`(${data.total})`);
            }
        }
    };

    return ns;
})(window.jQuery, window.Dom || {}, window._ || {});
